export const getDivisionId = (division: any): string => {
  if (typeof division === 'string' || typeof division === 'number') {
    return String(division)
  }

  if (!division || typeof division !== 'object') return ''

  const possibleKeys = ['id', 'divisionId', 'code', 'value']

  for (const key of possibleKeys) {
    const value = division?.[key]
    if (typeof value === 'string' || typeof value === 'number') {
      return String(value)
    }
  }

  return ''
}

export const isDivision60User = (division: any): boolean =>
  getDivisionId(division) === '60'
